import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/mukun.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6626a8a0")

_pushScopeId("data-v-6626a8a0")
const _hoisted_1 = { class: "dt-open-api-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-choose-us" }, [
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-title" }, "为什么选择C30教育云"),
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-info" }, "专注核心产品极致应用，基于生态融合第三方优质应用，个性化应用可基于中台和无代码自定义应用业务的能力，快速实现"),
  /*#__PURE__*/_createVNode("div", { class: "dt-open-api-choose-us-charact" }, [
    /*#__PURE__*/_createVNode("div", { class: "charact-item" }, [
      /*#__PURE__*/_createVNode("i", { class: "charact-icon charact-open" }),
      /*#__PURE__*/_createVNode("p", { class: "charact-title" }, "开放"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "提供接口"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "实现合作伙伴无缝对接")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "charact-item" }, [
      /*#__PURE__*/_createVNode("i", { class: "charact-icon charact-fuse" }),
      /*#__PURE__*/_createVNode("p", { class: "charact-title" }, "融合"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "与百万开发者"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "共同打造教育生态")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "charact-item" }, [
      /*#__PURE__*/_createVNode("i", { class: "charact-icon charact-simple" }),
      /*#__PURE__*/_createVNode("p", { class: "charact-title" }, "简单"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "简单易用"),
      /*#__PURE__*/_createVNode("p", { class: "charact-content" }, "专业快速集成")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-content" }, [
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-title" }, "关于沐坤科技"),
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-info" }, "一家服务于基础教育、职业教育和高等教育的大型教育科技集团"),
  /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-main" }, [
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-introduce" }, [
      /*#__PURE__*/_createVNode("p", null, "沐坤科技是一家服务于基础教育、职业教育和高等教育的大型教育科技集团，致力于“科技赋能教育”。 通过控股、战略投资及与教育产业内头部企业的战略合作，沐坤科技打造了完整的教育产业生态， 提供覆盖师生、课堂、学校、区域，涵盖教学与管理全方位的产品体系与解决方案， 为用户提供底层数据打通的“闭环、生态级”产品应用。"),
      /*#__PURE__*/_createVNode("p", null, "秉承“创业精神、求真务实、专业极致、创新引领、生态思维、亲情关怀”的企业价值观， 沐坤科技在中国教育信息化领域持续进行产业与商业全方位的创新与探索，在多个领域实现里程碑式的突破， 逐步向“中国教育信息化领域第一方案提供者”迈进。沐坤科技坚持去中心化的生态发展观，做“有社会责任心”的企业， 专注科技赋能教育，和产业合作伙伴、商业合作伙伴以及用户共同成长。")
    ]),
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "dt-open-api-about-cover"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-c30" }, [
    /*#__PURE__*/_createVNode("p", { class: "dt-open-api-title" }, "关于C30教育云"),
    /*#__PURE__*/_createVNode("p", { class: "dt-open-api-info" }, "开启课堂新时代，单点极致，生态链接，数据驱动"),
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-c30-content" }, [
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-c30-item" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-title" }, "科学可视化教学资源"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-content" }, " 火花学院是科学可视化教学资源库，利用计算机图形学技术为中小学生展现难以理解的科学概念、科学现象、科学原理。资源库覆盖小学、初中、高中的数学、科学、物理、化学、生物、地理等学科，提供从素材、课件、微课、题目到教参书的成体系资源，通过帮助教师改进课堂授课方式，提升学生知识理解度和学习参与度，使学生拥有更好的学业表现。 ")
      ]),
      /*#__PURE__*/_createVNode("span", { class: "dt-open-api-about-c30-item-split" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-c30-item" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-title" }, "灵活的管理平台"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-content" }, " 提供包括校务、教务、师生发展、家校互动、校园文化、智慧数据在内的管理类应用，系统提供强大的平台实现空间、审批、业务、报表、集成等各项内容的自定义，具有“实用易用、深度融合、灵活可变”的特点。")
      ]),
      /*#__PURE__*/_createVNode("span", { class: "dt-open-api-about-c30-item-split" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-about-c30-item" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-title" }, " 常态化的教学平台"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-about-c30-item-content" }, "在线教学的国家队 智慧课堂的缔造者 构建全教学闭环的线上课堂 打造混合式教学的线下课堂 实现基于数据分析的智慧课堂 为学校插上互联网的翅膀")
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-box" }, [
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-title" }, "关于入驻"),
  /*#__PURE__*/_createVNode("p", { class: "dt-open-api-info" }, "支持多终端，应用接入四步法"),
  /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-content" }, [
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-cover register-cover" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-content" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-title" }, "注册开发者账号"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-info" }, "注册账号，提交认证材料， 成为平台认可的开发者")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-cover app-cover" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-content" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-title" }, "创建应用"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-info" }, "使用账号登录，进入个人中心，创建 自己的应用，获取相应的APPID")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-cover api-cover" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-content" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-title" }, "接入openAPI"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-info" }, "参考开发文档，在平台上获取接入 帮助，快速完成开发")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-cover debugger-cover" }),
      /*#__PURE__*/_createVNode("div", { class: "dt-open-api-settled-item-content" }, [
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-title" }, "调试并发布"),
        /*#__PURE__*/_createVNode("p", { class: "dt-open-api-settled-item-info" }, "提供完备的调试工具和沙箱环境，顺 利完成应用发布")
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_home_banner = _resolveComponent("home-banner")
  const _component_home_footer = _resolveComponent("home-footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_home_banner),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_home_footer)
  ]))
})